<template>
	<div v-if="itemContent || itemsAttributes || item.feedback_comment_widget" class="cd-tabs-container" ref="itemTabs">
		<Body :class="[bodyClass, {'fixed-cd-header': fixedHeader}]" />
		<ClientOnly>
			<div class="cd-tabs">
				<div class="cd-tab-wrapper">
					<a v-if="itemContent" @click="mobileBreakpoint ? flyoutActive('content') : scrollTo('#tab1', {offset: 50})" href="javascript:void(0)" class="cd-tab-title" :class="{'active': activeTab === 'tab1'}"><span v-html="labels.get('tab_product_description')"></span></a>
					<a v-if="itemsAttributes" @click="mobileBreakpoint ? flyoutActive('attr') : scrollTo('#tab2', {offset: 50})" href="javascript:void(0)" class="cd-tab-title" :class="{'active': activeTab === 'tab2'}"><span v-html="labels.get('tab_specs')"></span></a>
					<a v-if="safetyInfo" @click="mobileBreakpoint ? openSafetyFlyout() : scrollTo('#tab-safety', {offset: 50})" href="javascript:void(0)" class="cd-tab-title" :class="{'active': activeTab === 'tab-safety'}">
						<span v-html="labels.get('tab_safety', 'Varnostne informacije')"></span>
					</a>
					<a v-if="item.feedback_comment_widget" @click="mobileBreakpoint ? flyoutActive('comment') : scrollTo('#tab3', {offset: 50})" href="javascript:void(0)" class="cd-tab-title" :class="{'active': activeTab === 'tab3'}">
						<span v-html="labels.get('tab_comments')"></span>
						<div v-if="item.feedback_rate_widget" class="cd-tab-title-rate-section">
							<BaseFeedbackRatesWidget :data="item.feedback_rate_widget" v-slot="{rate, stars}">
								<span class="cp-rate rates-container" v-html="stars" />
								<span v-if="rate > 0" class="cd-tab-title-rate-average">{{ rate }}</span>
							</BaseFeedbackRatesWidget>
						</div>
					</a>
				</div>
			</div>
		</ClientOnly>
		<div class="cd-tabs-content cd-tab-wrapper" ref="itemTabsContent">
			<!-- Content -->
			<div v-if="itemContent || item?.element_content_state" class="cd-tab-body cd-tab-body-content" :class="{'cd-flyout': mobileBreakpoint, 'active': mContentActive}" id="tab1" ref="flyoutContainer">
				<div class="cd-tab-body-container">
					<div class="cd-tab-body-title" v-html="labels.get('tab_product_description')"></div>
					<div class="cd-tab-content cms-content state" v-if="item?.element_content_state">
						<BaseCmsLabel tag="h4" code="tab_product_state_description" />
						<div v-html="item.element_content_state"></div>
					</div>
					<div v-if="itemContent" id="itemContent" class="cd-tab-content cms-content">
						<div v-html="itemContent"></div>
					</div>
					<div v-if="mobileBreakpoint" class="cd-tab-bottom cd-flyout-bottom">
						<div class="cd-flyout-close-label" @click="flyoutClose">{{ labels.get('flyout_close') }}</div>
					</div>
				</div>
				<div v-if="mobileBreakpoint" @click="flyoutClose" class="cd-flyout-close"></div>
			</div>

			<!-- Attributes -->
			<div v-if="itemsAttributes" class="cd-tab-body cd-tab-body-specs" :class="{'cd-flyout': mobileBreakpoint, 'active': mAttrActive}" id="tab2" ref="flyoutContainer">
				<div class="cd-tab-body-container">
					<div class="cd-tab-body-title" v-html="labels.get('tab_specs')"></div>
					<div class="cd-tab-attributes">
						<div v-for="(item, key) in itemsAttributes" :key="key" class="cd-tab-attribute">
							<div class="cd-tab-attribute-title">{{ key }}</div>
							<div class="cd-tab-attribute-desc">
								<template v-if="item.values?.length">{{ item.values.join(', ') }}</template>
								<template v-if="item.unit"> {{ item.unit }}</template>
							</div>
						</div>
					</div>
					<ClientOnly>
						<div v-if="mobileBreakpoint" class="cd-tab-bottom cd-flyout-bottom">
							<div class="cd-flyout-close-label" @click="flyoutClose">{{ labels.get('flyout_close') }}</div>
						</div>
					</ClientOnly>
				</div>
				<div v-if="mobileBreakpoint" @click="flyoutClose" class="cd-flyout-close"></div>
			</div>

			<!-- Safety -->
			<div v-if="safetyInfo" class="cd-tab-body cd-tab-body-safety" :class="{'cd-flyout': mobileBreakpoint, 'active': mSafetyActive}" id="tab-safety">
				<div class="cd-tab-body-container">
					<div class="cd-tab-body-title" v-html="labels.get('tab_safety')"></div>
					<div class="cd-tab-content cms-content">
						<div class="safety-link" @click="openSafetyFlyout();"><BaseCmsLabel code="tab_safety_link" /></div>
					</div>
				</div>
			</div>

			<!-- Comments -->
			<div v-if="item.feedback_comment_widget" class="cd-tab-body cd-tab-comment" :class="{'cd-flyout': mobileBreakpoint, 'active': mCommentActive}" id="tab3" ref="flyoutContainer">
				<div class="cd-tab-body-container">
					<ClientOnly>
						<div class="cd-tab-body-title" v-html="labels.get('tab_comments')"></div>
						<div class="cd-comments-info">
							<BaseFeedbackRatesWidget :data="item.feedback_rate_widget" v-slot="{rate, stars, counter}">
								<div class="cd-comments-info-col1" :class="{'empty': counter == 0}">
									<div class="cd-comments-rate-section">
										<span class="cp-rate rates-container" v-html="stars" />
										<span v-if="rate > 0" class="cd-comments-rate-average">{{ rate }}</span>
									</div>
									<div class="cd-comments-qty" v-if="counter > 0">
										{{ labels.get('comments_qty').replace('%c%', counter) }}
									</div>
									<div class="cd-comments-qty" v-else>{{ labels.get('no_comments') }}</div>
									<button v-if="!mobileBreakpoint" class="cd-comments-form-button" :class="{'active': commentsForm}" @click="commentsForm = !commentsForm, itemData()">
										<span class="show">{{ labels.get('comments_show_form') }}</span>
										<span class="hide">{{ labels.get('comments_hide_form') }}</span>
									</button>
								</div>
								<div v-if="rate > 0" class="cd-comments-info-col2 cd-chart-items">
									<div class="cd-chart-item" v-for="rateChart in ratesChart" :key="rateChart.rate">
										<div class="cd-chart-rate">{{ rateChart.rate }}</div>
										<div class="cd-chart-bar"><span class="cd-chart-progress-bar" :style="{width: ((rateChart.counter / counter) * 100).toFixed(0) + '%'}"></span></div>
										<div class="cd-chart-qty">{{ rateChart.counter }}</div>
									</div>
								</div>
							</BaseFeedbackRatesWidget>
						</div>

						<button v-if="mobileBreakpoint" class="cd-comments-form-button mobile" :class="{'active': commentsForm}" @click="commentsForm = !commentsForm, itemData()">
							<span class="show">{{ labels.get('comments_show_form') }}</span>
							<span class="hide">{{ labels.get('comments_hide_form') }}</span>
						</button>
						<div class="comments-form active" v-show="commentsForm">
							<BaseFeedbackCommentsForm class="form-comment form-animated-label" v-slot="{fields, onReset, status}">
								<template v-if="!status?.success">
									<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
										<p class="field comment-field" :class="['comment-field-' + item.name, {'ffl-floated': floatingLabel, 'hidden': item.type == 'hidden'}]">
											<BaseFormInput />
											<BaseCmsLabel tag="label" :for="item.name" :code="item.name == 'message' ?  'form_comments_message' : item.name" />
											<span class="error" v-show="errorMessage" v-html="errorMessage" />
										</p>
									</BaseFormField>
									<div class="comment-button-container">
										<button class="btn btn-send-comment" type="submit">{{ labels.get('send_comment') }}</button>
										<div class="comment-form-note">{{ labels.get('comment_form_note') }}</div>
									</div>
								</template>

								<div class="comment-success" v-if="status?.success">
									<div v-html="labels.get('comment_success')" />
									<a href="javascript:void(0);" @click="onReset">{{ labels.get('comment_add_new') }}</a>
								</div>
							</BaseFeedbackCommentsForm>
						</div>

						<BaseFeedbackComments :items="item.feedback_comment_widget.items" v-slot="{items: comments}">
							<div class="comments-list comments_data comments-container" id="comment-list">
								<div id="comment-list-items">
									<div class="comment-list-cnt">
										<FeedbackCommentEntry v-for="comment in comments" :key="comment.id" :item="comment" />
									</div>
								</div>
							</div>
						</BaseFeedbackComments>
						<div v-if="mobileBreakpoint" class="cd-tab-bottom cd-flyout-bottom">
							<div class="cd-flyout-close-label" @click="flyoutClose">{{ labels.get('flyout_close') }}</div>
						</div>
					</ClientOnly>
				</div>
				<div v-if="mobileBreakpoint" @click="flyoutClose" class="cd-flyout-close"></div>
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['item']);
	const mContentActive = ref(false);
	const mAttrActive = ref(false);
	const mCommentActive = ref(false);
	const mSafetyActive = ref(false);
	const {get: getLang} = useLang();
	const {emit, bus} = useEventBus();
	const {scrollTo} = useDom();
	const {addScript, uninstallScript} = useMeta();
	const {isObjectEmpty} = useArrayUtils();

	//fixed tabs
	const itemTabs = ref()
	const itemTabsContent = ref()
	const activeTab = ref(null);
	const bodyClass = ref(null);

	const fixedHeader = ref(false)
	const onScrollDetail = () => {
		if(itemContent.value || itemsAttributes.value || props.item.feedback_comment_widget) {
			//fixed tabs
			const topTabs = (itemTabs.value) ? itemTabs.value.getBoundingClientRect().top : 0;
			fixedHeader.value = (topTabs <= 64) ? true : false;

			//active tab
			const itemTabElements = itemTabsContent.value?.querySelectorAll('.cd-tab-body');
			if(itemTabElements?.length > 0) {
				itemTabElements.forEach((itemTabElement) => {
					const { top } = itemTabElement.getBoundingClientRect()
					if (top <= 80) {
						activeTab.value = itemTabElement.id
					}
				})
			}
		}
	};

	//content
	let descriptionLength = 0
	let pimMinChar = props.item.appconfig?.product_pim_min_chars ? props.item.appconfig.product_pim_min_chars : 0;
	const shortDescriptionText = computed(() => {
		return props.item?.short_description ? props.item.short_description.trim().replace(/<(?:.|\n)*?>/gm, '') : null;
	});
	const contentText = computed(() => {
		// /<(?!iframe(?:\s|>))(?:.|\n)*?>(?<!<\/iframe>)/gm
		return props.item?.content ? props.item.content.trim().replace(/<(?!iframe(?:\s|>))(?!\/iframe)(?:.|\n)*?>/gm, '') : null;
	});

	const flixContent = ref(null);

	watch(
		() => props.item,
		async (newValue) => {
			// Reload flix script with new data when configurable product is changed
			uninstallFlix();
			await fetchFlixWebcatalog();
			loadFlix();

			if(props.item?.check_lists && props.item?.check_lists?.['webcatalog_cs-lt'] == true) {
				window.addEventListener('message', parhelion, false);
			}
		}
	);

	const itemContent = computed(() => {
		let value = '';

		const shortDescriptionTextLength = (shortDescriptionText.value) ? shortDescriptionText.value.length : 0;
		const contentTextLength = (contentText.value) ? contentText.value.length : 0;
		if((props.item.short_description && props.item.short_description !== "") && shortDescriptionTextLength >= 10 && shortDescriptionText.value != contentText.value) {
			value += props.item.short_description
			descriptionLength = shortDescriptionTextLength
		}
		if (props.item.content && contentTextLength >= 10) {
			if (value) {
				value += '<p>&nbsp;</p>';
			}
			value += props.item.content;
			descriptionLength = shortDescriptionTextLength + contentTextLength;
		}

		if(descriptionLength < pimMinChar) {
			if (flixContent?.value?.event == 'matchhit') {
				value = '<div/>';
			} else if(props.item.check_lists && props.item.check_lists['webcatalog_cs-lb'] == true) {
				value = '<div class="loadbeeTabContent" data-loadbee-apikey="CBTGtm5pktttLraG5zsAZRmvfmKdzbfZ" data-loadbee-gtintype="ean" data-loadbee-gtin="' + props.item.ean_code + '" data-loadbee-locale="sl_SI" data-loadbee-debug="false"></div>';
			} else if(props.item.check_lists && props.item.check_lists['webcatalog_cs-lt'] == true) {
				value = '<iframe width="100%" src="https://bigbang.parhelion.hr/?ean=' + props.item.ean_code + '" frameborder="0" scrolling="auto" id="parhelion-frames"></iframe>';
			}
		}

		return value;
	});

	//attributes
	const itemsAttributes = computed(() => {
		let itemsAttributes = {}
		if(props.item.attributes?.length) {
			props.item.attributes.forEach(itemAttribute => {
				if(!['attribute_badges', 'superbenefits', 'katalog-9001'].includes(itemAttribute.code)) {
					const key = itemAttribute.attribute_title;
					const value = itemAttribute.title;
					const unit = itemAttribute.attribute_unit;

					if (!itemsAttributes[key]) {
					itemsAttributes[key] = { values: [], unit: unit || '' };
					}

					itemsAttributes[key].values.push(value);
				}
			});
		}

		const labels = {
			months12: '12 mesecev',
			months24: '24 mesecev',
			months36: '36 mesecev',
			months48: '48 mesecev',
			months60: '60 mesecev',
		};

		// warranty
		const warranty = (props.item.channel_element_warranty) ? props.item.channel_element_warranty : props.item.element_warranty;
		if(warranty) itemsAttributes['Garancija'] = { values: [labels[warranty] || warranty], unit: '' };

		// guarantee
		const guarantee = (props.item.channel_element_guarantee) ? props.item.channel_element_guarantee : props.item.element_guarantee;
		if(guarantee) itemsAttributes['Jamstvo'] = { values: [labels[guarantee] || guarantee], unit: '' };

		return itemsAttributes;
	});

	const safetyInfo = computed(() => {
		if(!props.item) return false;
		const item = props.item;
		const lang = getLang();
		let data = {};

		if(item.element_safety_documents?.[lang]?.length) data.documents = item.element_safety_documents[lang];
		if(item.element_safety_images?.[lang]?.length) data.images = item.element_safety_images[lang];
		if(item.element_safety_info?.[lang]?.length) data.info = item.element_safety_info[lang];

		if(item.element_sman_name) data.brandName = item.element_sman_name;
		if(item.element_sman_code) data.brandZipCode = item.element_sman_code;
		if(item.element_sman_country) data.brandCountry = item.element_sman_country;
		if(item.element_sman_email) data.brandEmail = item.element_sman_email;

		if(item.element_rp_name) data.rpName = item.element_rp_name;
		if(item.element_rp_zipcode) data.rpZipCode = item.element_rp_zipcode;
		if(item.element_rp_country) data.rpCountry = item.element_rp_country;
		if(item.element_rp_email) data.rpEmail = item.element_rp_email;

		return isObjectEmpty(data) ? null : data;
	})

	function openSafetyFlyout() {
		emit('flyoutUpdate', {'flyout_title': labels.get('tab_safety'), 'flyout_mode': 'safety', 'flyout_content': safetyInfo})
	}

	// rates chart
	const ratesChart = reactive([]);
	for (let i = 1; i <= 5; i++) {
		ratesChart.push({
			rate: i,
			counter: 0,
		});
	}

	function itemData() {
		const comments = props.item.feedback_comment_widget?.items;
		if(comments?.length) {
			Object.values(comments).forEach(el => {
				if (el.rate) {
					ratesChart[el.rate - 1].counter++;
				}
			});
		}
	}

	// show/hide comments form
	const commentsForm = ref(0);

	//rwd
	const {mobileBreakpoint} = inject('rwd');

	//mobile flyout
	function flyoutActive(value) {
		if(mobileBreakpoint.value) {
			bodyClass.value = 'flyout-page cd-flyout-active';
			if(value == 'content') {
				mContentActive.value = true;
			} else if(value == 'attr') {
				mAttrActive.value = true;
			} else if(value == 'comment') {
				mCommentActive.value = true;
			} else if(value == 'safety') {
				mSafetyActive.value = true;
			}
		}
	}

	//mobile flyout activated from parent component
	watch(
		() => bus.value,
		(newValue) => {
			if (newValue.event === 'flyoutCommentMobile') {
				flyoutActive('comment')
			}
		}
	);

	function flyoutClose() {
		bodyClass.value = null;
		mContentActive.value = false;
		mAttrActive.value = false;
		mCommentActive.value = false;
		mSafetyActive.value = false;
	}

	// close modal on outside click and escape keyup
	const flyoutContainer = ref(null);

	//lifecycle
	onMounted(async () => {
		window.addEventListener('scroll', onScrollDetail);

		//active tab
		const firstTab = (itemTabsContent.value) ? itemTabsContent.value.querySelectorAll('.cd-tab-body') : null;
		if(firstTab?.length > 0) {
			activeTab.value = firstTab[0].id
		}

		// Check if Flix content is available and install script
		await fetchFlixWebcatalog();
		loadFlix();

		// Install LoadBee
		if(props.item?.check_lists && props.item?.check_lists?.['webcatalog_cs-lb'] == true) {
			addScript({
				src: 'https://cdn.loadbee.com/js/loadbee_integration.js',
				key: 'loadbee',
			});
		}

		if(props.item?.check_lists && props.item?.check_lists?.['webcatalog_cs-lt'] == true) {
			window.addEventListener('message', parhelion, false);
		}
	});

	onBeforeUnmount(() => {
		window.removeEventListener('scroll', onScrollDetail);
		window.removeEventListener('message', parhelion, false);
		uninstallScript({key: 'flix'});
		uninstallScript({key: 'loadbee'});
	});

	// Append flix script to page element where content is rendered (flix is creating its own element)
	function loadFlix() {
		if(flixContent?.value?.event != 'matchhit') return;
		addScript({
			src: 'https://media.flixfacts.com/js/loader.js',
			key: 'flix',
			dataAttributes: {
				'flix-distributor': '10251',
				'flix-language': 'sl',
				'flix-brand': props.item?.manufacturer_title || '',
				'flix-ean': props.item?.ean_code || '',
				'flix-sku': '',
				'flix-button': 'flix-minisite',
				'flix-inpage': 'flix-inpage',
				'flix-button-image': '',
				'flix-fallback-language': 'en',
				'flix-autoload': 'inpage',
				'flix-price': ''
			},
			appendTo: '#itemContent'
		});
	}

	function uninstallFlix() {
		uninstallScript({
			key: 'flix',
			onUninstall: () => {
				const el = document.querySelector('#flix-inpage');
				if(el) el.remove();
			}
		});
	}

	async function fetchFlixWebcatalog() {
		const eanCode = props.item?.ean_code ? props.item.ean_code : '';
		if(eanCode && props.item?.check_lists && props.item?.check_lists['webcatalog_cs-fm'] == true) {
			try{
				flixContent.value = await $fetch(`https://media.flixcar.com/delivery/webcall/match/10251/sl/ean/${eanCode}?resp=0`);
			} catch (e) {
				flixContent.value = null;
			}
		}
	}

	function parhelion(e) {
		if (e.hasOwnProperty('originalEvent')) {
			var origin = e.originalEvent.origin || e.origin;
		} else {
			var origin = e.origin;
		}
		if (origin !== 'https://bigbang.parhelion.hr') return
		let box = document.getElementById('parhelion-frames');
		if(box){
			box.style.height = e.data.frameHeight + 'px';
		}
	}
</script>

<style lang="less" scoped>
	.safety-link{
		position: relative; display: inline-flex; align-items: center; cursor: pointer; .transition(color);
		&:after{position: relative; .icon-arrow(); font: 10px/1 @fonti; .scaleX(-1); font-weight: bold; margin-left: 8px; margin-top: 2px;}
		&:hover{color: @blue;}
	}
	.cd-tab-wrapper{
		width: 820px; margin: 0 auto;

		@media (max-width: @m){width: auto; margin: 0 auto;}
	}
	.cd-tabs-container{
		margin-bottom: 60px; position: relative;
		.share{display: none;}

		@media (max-width: @t){
			.share{display: flex;}
		}
		@media (max-width: @m){margin-bottom: 15px;}
	}
	.cd-tabs{
		display: flex; list-style: none; background: @white; border-bottom: 1px solid @borderColor; border-top: 1px solid @borderColor; position: sticky; top: -1px; z-index: 11;
		&>.cd-tab-wrapper{display: flex;}

		@media (max-width: @m){
			display: block; border: none; position: relative;
			&>.cd-tab-wrapper{display: block;}
		}
	}
	.cd-tab-title{
		display: flex; align-items: center; justify-content: center; flex-grow: 1; height: 60px; margin: -1px -1px -1px 0; border: 1px solid @borderColor; border-top: none; border-bottom: none; font-size: 17px; line-height: 1.4; font-weight: 600; text-decoration: none; color: #7891A9; .transition(all);
		span{
			display: flex; align-items: center; height: 100%; position: relative;
			&:after{.pseudo(auto,3px); background: @blue; left: 0; right: 0; bottom: 0; opacity: 0; .transition(opacity);}
		}
		@media (min-width: @t){
			&:hover{
				text-decoration: none; color: @textColor;
				span:after{opacity: 1;}
			}
		}

		&.active{
			color: @textColor;
			span:after{opacity: 1;}
		}

		@media (max-width: @m){
			justify-content: flex-start; width: 100%; margin: 0 0 -1px; padding: 5px 50px 5px 15px; border: 1px solid @borderColor; border-left: none; border-right: none; color: @textColor; position: relative;
			&:before{.icon-arrow-down(); font: 12px/12px @fonti; font-weight: normal; color: @blue; position: absolute; right: 17px; .rotate(-90deg);}
			span:after{content: none;}
			&:hover{color: @textColor;}
		}
	}
	.cd-tab-title-rate-section{
		display: none;

		@media (max-width: @m){
			display: flex; align-items: center; margin-left: 10px;
			.cp-rate{
				height: 16px;
				span{
					width: 16px; height: 16px;
					&:after{width: 16px; height: 16px; right: unset; bottom: unset; opacity: 1;}
				}
			}
		}
	}
	.cd-tab-title-rate-average{margin-left: 4px; font-size: 14px; line-height: 1.4;}
	.cd-tab-body{
		padding: 45px 0 15px; position: relative;

		@media (max-width: @m){padding: 0; position: fixed;}
	}

	.cd-tab-body-container{
		@media (max-width: @m){height: 100%; overflow-y: auto; overflow-x: hidden; font-size: 15px; line-height: 1.5; padding: 15px 10px 90px 15px; border-right: 7px solid #ffffff; border-top-left-radius: 10px; border-top-right-radius: 10px}
	}
	.cd-tab-body-title{
		padding: 0 0 15px; font-size: 32px; line-height: 1.4; font-weight: 600;

		@media (max-width: @t){font-size: 26px;}
		@media (max-width: @m){font-size: 17px;}
	}
	.cd-tab-content{
		flex-grow: unset; padding: 0; font-size: 16px; line-height: 1.6;
		h2,h3,h4,h5{padding: 20px 0 15px;}
		:deep(iframe){max-height: unset;}
		&.state{
			margin-bottom: 30px; padding: 20px; background: #F3F6FA;
			h4{padding-top: 0;}
		}

		@media (max-width: @m){
			h2,h3,h4,h5{padding: 10px 0 5px;}
			&.state{
				margin-bottom: 20px; padding: 15px 10px; background: #F3F6FA;
			}
		}
		@media (max-width: @ms){
			:deep(iframe){max-height: unset!important;}
		}
	}
	.cd-tab-bottom{
		display: none;

		@media (max-width: @m){display: flex;}
	}

	.cd-tab-attributes{position: relative;}
	.cd-tab-attribute{
		font-size: 16px; line-height: 1.6; display: flex; justify-content: space-between; padding: 10px 20px; .transition(background);
		.cd-tab-attribute-title, .cd-tab-attribute-desc{width: 50%;}
		.cd-tab-attribute-title{padding-right: 10px;}
		.cd-tab-attribute-desc{text-align: right; padding-left: 10px;}

		@media (max-width: @m){padding: 12px 10px;}
	}
	.cd-tab-attribute:nth-child(odd){background: #F3F6FA;}
</style>
